export const TasksImpacts = {
    both: {
        title: 'Both'
    },
    likelihood: {
        title: 'Likelihood'
    },
    damage: {
        title: 'Damage'
    }
}

export const IMAGE_ACCEPT_TYPES = "image/png,image/jpeg,image/webp,image/svg+xml";

export const ReportTypes = {
    "1": {
        label: "Anonymous Report"
    },
    "2": {
        label: "Confidential Report"
    },
    "3": {
        label: "Arrange a Meeting"
    },
    "4": {
        label: "Voice Report"
    }
}


/**
 * The colors are the keys that api returns
 */
export const ResidualRisksRates = {
    "4EB8B1": {
        title: "Insignificant",
        color: "#4EB8B1"
    },
    "59C94F": {
        title: "Minor",
        color: "#59C94F"
    },
    "FFA049": {
        title: "Noticeable",
        color: "#FFA049"
    },
    "FF4949": {
        title: "Critical",
        color: "#FF4949"
    },
    "822626": {
        title: "Existence - threatening",
        color: "#822626"
    }
}

export const OrdersStatuses = {
    'pending': {
        title: 'Pending',
        color: '#FFA049'
    },
    'processing': {
        title: 'Processing',
        color: '#59C94F'
    },
    'on-hold': {
        title: 'On Hold',
        color: '#4EB8B1'
    },
    'completed': {
        title: 'Completed',
        color: '#59C94F'
    },
    'cancelled': {
        title: 'Cancelled',
        color: '#FF4949'
    },
    'refunded': {
        title: 'Refunded',
        color: '#822626'
    },
    'failed': {
        title: 'Failed',
        color: '#FF4949'
    },
    'trash': {
        title: 'Trash',
        color: '#822626'
    }
};

export const SubscriptionsStatues = {
    'active': {
        title: 'Active',
        color: '#59C94F',
        isCancellable: true
    },
    'pending': {
        title: 'Pending',
        color: '#FFA049'
    },
    'on-hold': {
        title: 'On Hold',
        color: '#4EB8B1',
        isCancellable: true
    },
    'cancelled': {
        title: 'Cancelled',
        color: '#FF4949'
    },
    'switched': {
        title: 'Switched',
        color: '#822626'
    },
    'expired': {
        title: 'Expired',
        color: '#FF4949'
    },
    'trash': {
        title: 'Trash',
        color: '#822626'
    },
    'pending-cancel': {
        title: 'Pending Cancel',
        color: '#FFA049'
    }
};